import {
  FaBalanceScale,
  FaBroadcastTower,
  FaClipboardList,
  FaDesktop,
  FaLayerGroup,
  FaMedal,
  FaPlayCircle,
  FaRegImages,
  FaTrophy,
} from "react-icons/fa";

export const TOURNAMENT_GALLERY_CATEGORIES = [
  {
    key: "all",
    label: "Tous les écrans",
    shortLabel: "Tous",
    icon: FaRegImages,
  },
  {
    key: "preparation",
    label: "Préparation",
    shortLabel: "Préparation",
    icon: FaClipboardList,
  },
  {
    key: "weighing",
    label: "Pesées",
    shortLabel: "Pesées",
    icon: FaBalanceScale,
  },
  {
    key: "distribution",
    label: "Répartitions",
    shortLabel: "Répartitions",
    icon: FaLayerGroup,
  },
  {
    key: "fights",
    label: "Combats",
    shortLabel: "Combats",
    icon: FaPlayCircle,
  },
  {
    key: "scoreboard",
    label: "Scoreboards",
    shortLabel: "Scoreboards",
    icon: FaDesktop,
  },
  {
    key: "results",
    label: "Résultats",
    shortLabel: "Résultats",
    icon: FaMedal,
  },
];

export const TOURNAMENT_GALLERY_SLIDES = [
  {
    id: "tournoi-home",
    src: "/images/MACTournoi/01.png",
    alt: "Accueil de MonAppliTournoi",
    title: "Accueil de l’application",
    category: "preparation",
    audience: "Organisateur",
    description:
      "Une page d’accueil claire pour accéder rapidement aux compétitions, aux outils de gestion et aux résultats publics.",
    tags: [
      "Tableau de bord",
      "Navigation rapide",
      "Compétitions",
    ],
  },
  {
    id: "tournoi-create",
    src: "/images/MACTournoi/02.png",
    alt: "Création d’une compétition dans MonAppliTournoi",
    title: "Création de la compétition",
    category: "preparation",
    audience: "Organisateur",
    description:
      "Paramétrage du tournoi, de la date, du lieu, des catégories, des tapis et des principales options d’organisation.",
    tags: [
      "Paramètres",
      "Catégories",
      "Configuration",
    ],
  },
  {
    id: "tournoi-navigation",
    src: "/images/MACTournoi/03.png",
    alt: "Page compétition et menus de MonAppliTournoi",
    title: "Pilotage de la compétition",
    category: "preparation",
    audience: "Organisateur",
    description:
      "Tous les outils du tournoi sont regroupés dans une page centrale pour faciliter le travail de l’équipe organisatrice.",
    tags: [
      "Menus",
      "Pilotage",
      "Organisation",
    ],
  },
  {
    id: "tournoi-weighing",
    src: "/images/MACTournoi/04.png",
    alt: "Gestion des pesées et des présences",
    title: "Pesées et présences",
    category: "weighing",
    audience: "Organisateur",
    description:
      "Contrôle des compétiteurs présents, validation des poids et ajustement des catégories avant la répartition.",
    tags: [
      "Poids",
      "Présences",
      "Contrôle",
    ],
  },
  {
    id: "tournoi-distribution",
    src: "/images/MACTournoi/05.png",
    alt: "Répartition des compétiteurs",
    title: "Répartition des compétiteurs",
    category: "distribution",
    audience: "Organisateur",
    description:
      "Création des poules et tableaux selon l’âge, le poids, le grade et les règles définies pour la compétition.",
    tags: [
      "Poules",
      "Tableaux",
      "Catégories",
    ],
  },
  {
    id: "tournoi-fights",
    src: "/images/MACTournoi/06.png",
    alt: "Gestion des combats sur les différents tapis",
    title: "Gestion des combats",
    category: "fights",
    audience: "Table d’arbitrage",
    description:
      "Chaque table retrouve les combats affectés à son tapis et suit leur déroulement dans l’ordre prévu.",
    tags: [
      "Tapis",
      "Ordre de passage",
      "Combats",
    ],
  },
  {
    id: "tournoi-scoreboard-table",
    src: "/images/MACTournoi/07.png",
    alt: "Interface du tableau de score pour la table d’arbitrage",
    title: "Table de marque",
    category: "scoreboard",
    audience: "Table d’arbitrage",
    description:
      "La table saisit les scores, les pénalités et le résultat du combat depuis une interface adaptée.",
    tags: [
      "Score",
      "Pénalités",
      "Vainqueur",
    ],
  },
  {
    id: "tournoi-scoreboard-public",
    src: "/images/MACTournoi/11.png",
    alt: "Affichage public du tableau de score",
    title: "Affichage sur le tapis",
    category: "scoreboard",
    audience: "Public",
    description:
      "Un second écran peut afficher le score, le temps de combat et les informations des combattants.",
    tags: [
      "Double écran",
      "Affichage public",
      "Temps réel",
    ],
  },
  {
    id: "tournoi-results",
    src: "/images/MACTournoi/08.png",
    alt: "Résultats de la compétition",
    title: "Résultats de la compétition",
    category: "results",
    audience: "Organisateur",
    description:
      "Les résultats saisis par les tables alimentent automatiquement le classement général de la compétition.",
    tags: [
      "Classement",
      "Résultats",
      "Publication",
    ],
  },
  {
    id: "tournoi-podiums",
    src: "/images/MACTournoi/08a.png",
    alt: "Résultats par poules et préparation des podiums",
    title: "Podiums par poules",
    category: "results",
    audience: "Organisateur",
    description:
      "Les classements de chaque poule permettent de préparer rapidement les récompenses et les podiums.",
    tags: [
      "Podiums",
      "Médailles",
      "Classement",
    ],
  },
  {
    id: "tournoi-statistics",
    src: "/images/MACTournoi/09.png",
    alt: "Statistiques du tournoi",
    title: "Statistiques de la compétition",
    category: "results",
    audience: "Organisateur",
    description:
      "Analysez la participation, les catégories, les clubs représentés et les principaux indicateurs du tournoi.",
    tags: [
      "Statistiques",
      "Participation",
      "Analyse",
    ],
  },
  {
    id: "tournoi-public-results",
    src: "/images/MACTournoi/10.png",
    alt: "Résultats publics pour les clubs et les coachs",
    title: "Résultats publics",
    category: "results",
    audience: "Clubs et public",
    description:
      "Les coachs et les visiteurs consultent l’avancement, les résultats et les classements depuis leur téléphone.",
    tags: [
      "QR Code",
      "Coachs",
      "Résultats en direct",
    ],
  },
];

export const TOURNAMENT_GALLERY_STATS = [
  {
    icon: FaRegImages,
    value: "12 écrans",
    label: "pour découvrir l’application",
  },
  {
    icon: FaLayerGroup,
    value: "7 étapes",
    label: "de la préparation aux résultats",
  },
  {
    icon: FaBroadcastTower,
    value: "Temps réel",
    label: "pour les tables et le public",
  },
  {
    icon: FaTrophy,
    value: "Jour J",
    label: "une interface pensée pour le terrain",
  },
];